var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-tab-container"},[(_vm.products.length>0)?_c('ProductsTable',{attrs:{"categories":_vm.categories,"products":_vm.products}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }